/*
 *
 * hdd 资源管理器中的模态框组件
 *
 */

import { Button, Modal, Tree, Cascader, Col, Row, message } from 'antd';
import { Input as AntInput } from '&/components/AntdEncapsulation';
import { DownOutlined } from '@ant-design/icons';
import {
    deleteResource,
    editSuspended,
    moveResource,
    bindEnterpriseLibraryResource,
} from '@/api/hdd/ceiling';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import infoIcon from '@/assets/img/hdd/info.svg';

import './index.scss';

export default function CeilingModals(props) {
    const {
        detail,
        deleteOpen,
        setDeleteOpen,
        moveOpen,
        setMoveOpen,
        editOpen,
        setEditOpen,
        detailOpen,
        setDetailOpen,
        treeData,
        forceUpdate,
        setPage,
        list,
        deleteResourceApi = deleteResource,
        editResourceApi = editSuspended,
        moveResourceApi = moveResource,
        publishOpen = false,
        setPublishOpen = () => {},
        publishTreeData = [],
        bindResourceApi = bindEnterpriseLibraryResource,
        publishTreeLoading = false,
        isCustomPublic = false,
        folderId = '',
    } = props;

    const [selectedKey, setSelectedKey] = useState('');
    const [moveExpandedKeys, setMoveExpandedKeys] = useState([]);
    const [publishSelectedPath, setPublishSelectedPath] = useState([]);
    const [loading, setLoading] = useState(false);

    // 将 Tree 格式的数据转换为 Cascader 格式
    const convertTreeToCascaderOptions = treeData => {
        if (!Array.isArray(treeData)) return [];
        return treeData.map(node => ({
            label: node.title,
            value: node.key,
            children:
                node.children && node.children.length > 0
                    ? convertTreeToCascaderOptions(node.children)
                    : undefined,
        }));
    };

    const onDeleteOk = () => {
        setLoading(true);
        deleteResourceApi({
            type: 1,
            resourceId: typeof detail.id === 'object' ? detail.id : [detail.id],
        })
            .then(() => {
                setDeleteOpen(false);
                if (
                    list.length === 1 ||
                    (typeof detail.id === 'object' &&
                        list.length === detail.id.length)
                ) {
                    setPage(1);
                }
                forceUpdate();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const [name, setName] = useState(detail?.name);

    useEffect(() => {
        setName(detail?.name);
    }, [detail]);

    const nameSpecialCharPattern =
        /^[^\\/:*?"<>|；？\u201c\u201d\u2018\u2019]*$/;

    const onEditOk = () => {
        if (!name) {
            message.error('模型名称不能为空');
            return;
        }
        if (!nameSpecialCharPattern.test(name)) {
            message.error('名称不能包含 \\ / : * ? " < > | 等特殊字符');
            return;
        }
        setLoading(true);
        const params = isCustomPublic
            ? { modelList: [{ sourceCode: detail.code, name: name }] }
            : { sourceCode: detail.code, name: name };
        editResourceApi(params)
            .then(() => {
                // getList(activeKey);
                setEditOpen(false);
                message.success('模型名称修改成功');
                forceUpdate();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onMoveOk = () => {
        if (!selectedKey || selectedKey.length === 0) {
            message.error('请先选择目标分类，再移动');
            return;
        }

        if (isCustomPublic) {
            const sourceCodes = Array.isArray(detail.code)
                ? detail.code
                : [detail.code];
            const isEmpty = sourceCodes.length >= list.length;
            setLoading(true);
            moveResourceApi({
                sourceCode: sourceCodes,
                oldFolderId: folderId,
                newFolderId: selectedKey,
            })
                .then(() => {
                    setMoveOpen(false);
                    if (isEmpty) {
                        setPage(1);
                    }
                    message.success('移动成功');
                    forceUpdate();
                })
                .finally(() => {
                    setLoading(false);
                });
            return;
        }

        let apiName, payloadName, isEmpty;
        console.log('detail', detail);
        if (Array.isArray(detail.code)) {
            apiName = moveResourceApi;
            payloadName = 'sourceCodes';
            console.log('detail.code', detail.code);
            isEmpty = detail.code.length === list.length;
        } else {
            apiName = editResourceApi;
            payloadName = 'sourceCode';
            isEmpty = list.length === 1;
        }
        setLoading(true);
        apiName({ [payloadName]: detail.code, folderId: selectedKey })
            .then(() => {
                // getList(activeKey);
                setMoveOpen(false);
                if (isEmpty) {
                    setPage(1);
                }
                message.success('移动成功');
                forceUpdate();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onPublishChange = value => {
        setPublishSelectedPath(value || []);
    };

    const onPublishOk = () => {
        const sourceCode = Array.isArray(detail?.code)
            ? detail.code[0]
            : detail?.code;

        if (!sourceCode) {
            message.error('未找到素材信息');
            return;
        }

        if (!publishSelectedPath || publishSelectedPath.length === 0) {
            message.error('请先选择目标分类，再公开');
            return;
        }

        const selectedFolderId =
            publishSelectedPath[publishSelectedPath.length - 1];
        setLoading(true);
        bindResourceApi({
            sourceCode,
            folderId: selectedFolderId,
        })
            .then(() => {
                message.success('公开成功');
                setPublishOpen(false);
                forceUpdate();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onDetailOk = () => {
        setDetailOpen(false);
    };

    const onSelect = (selectedKeys, info) => {
        setSelectedKey(selectedKeys[0]);
    };

    const onMoveTreeClick = (e, node) => {
        if (!node || node.selectable !== false) return;
        const children = node.children;
        if (!Array.isArray(children) || children.length === 0) return;

        const { key } = node;
        setMoveExpandedKeys(prev => {
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
            } else {
                next.add(key);
            }
            return Array.from(next);
        });
    };

    const getSize = detail => {
        if (!detail) return '';
        return `${detail.length || detail.modelLength}*${
            detail.width || detail.modelWidth
        }*${detail.high || detail.modelHigh}mm`;
    };

    const getDate = (detail, date) => {
        if (!detail) return '';
        return dayjs.unix(date).format('YYYY-MM-DD HH:mm:ss');
    };

    useEffect(() => {
        setSelectedKey([]);
        if (moveOpen && treeData.length > 0) {
            setMoveExpandedKeys(treeData.map(node => node.key));
        }
    }, [moveOpen]);

    useEffect(() => {
        if (!publishOpen) {
            setPublishSelectedPath([]);
        }
    }, [publishOpen]);

    return (
        <div className="ceiling-modals-wrap">
            <Modal
                title="提示"
                visible={deleteOpen}
                onOk={onDeleteOk}
                onCancel={() => setDeleteOpen(false)}
                okText="确认"
                cancelText="取消"
                width={369}
                getContainer={() =>
                    document.querySelector('.ceiling-modals-wrap')
                }
                footer={[
                    <Button
                        key="submit"
                        className="confirm-btn"
                        loading={loading}
                        onClick={onDeleteOk}>
                        确定
                    </Button>,
                    <Button key="back" onClick={() => setDeleteOpen(false)}>
                        取消
                    </Button>,
                ]}>
                <p className="delete-confirm-text">
                    <img src={infoIcon} alt="info" />
                    确定要删除所选素材吗？
                </p>
            </Modal>

            <Modal
                title="填写模型信息"
                visible={editOpen}
                onOk={onEditOk}
                onCancel={() => setEditOpen(false)}
                okText="确认"
                cancelText="取消"
                width={369}
                className="edit-modal"
                getContainer={() =>
                    document.querySelector('.ceiling-modals-wrap')
                }
                footer={[
                    <Button
                        key="submit"
                        className="confirm-btn"
                        loading={loading}
                        onClick={onEditOk}>
                        确定
                    </Button>,
                    <Button key="back" onClick={() => setEditOpen(false)}>
                        取消
                    </Button>,
                ]}>
                <Row>
                    <Col span={6}>
                        <span>
                            <span style={{ color: '#e84f47' }}>*</span>
                            模型名称：
                        </span>
                    </Col>
                    <Col span={18}>
                        <AntInput
                            maxLength={50}
                            onChange={e => setName(e.target.value)}
                            value={name}
                        />
                    </Col>
                </Row>
            </Modal>

            <Modal
                title="移动到"
                visible={moveOpen}
                onOk={onMoveOk}
                onCancel={() => setMoveOpen(false)}
                okText="确认"
                cancelText="取消"
                width={300}
                getContainer={() =>
                    document.querySelector('.ceiling-modals-wrap')
                }
                footer={[
                    <Button
                        key="submit"
                        className="confirm-btn"
                        loading={loading}
                        onClick={onMoveOk}>
                        确定
                    </Button>,
                    <Button key="back" onClick={() => setMoveOpen(false)}>
                        取消
                    </Button>,
                ]}>
                {treeData.length > 0 && (
                    <Tree
                        blockNode
                        switcherIcon={<DownOutlined />}
                        expandedKeys={moveExpandedKeys}
                        onExpand={keys => setMoveExpandedKeys(keys)}
                        onClick={onMoveTreeClick}
                        onSelect={onSelect}
                        selectedKeys={[selectedKey]}
                        treeData={treeData}
                    />
                )}
            </Modal>

            <Modal
                title="公开到"
                visible={publishOpen}
                onOk={onPublishOk}
                onCancel={() => setPublishOpen(false)}
                okText="确认"
                cancelText="取消"
                width={400}
                getContainer={() =>
                    document.querySelector('.ceiling-modals-wrap')
                }
                footer={[
                    <Button
                        key="submit"
                        className="confirm-btn"
                        loading={loading}
                        onClick={onPublishOk}>
                        确定
                    </Button>,
                    <Button key="back" onClick={() => setPublishOpen(false)}>
                        取消
                    </Button>,
                ]}>
                {publishTreeLoading ? (
                    <div className="modal-tip">分类加载中...</div>
                ) : publishTreeData.length > 0 ? (
                    <Cascader
                        options={convertTreeToCascaderOptions(publishTreeData)}
                        onChange={onPublishChange}
                        value={publishSelectedPath}
                        placeholder="请选择目标分类"
                        changeOnSelect
                        style={{ width: '100%' }}
                        getPopupContainer={triggerNode =>
                            triggerNode.parentNode
                        }
                    />
                ) : (
                    <div className="modal-tip">暂无可选分类</div>
                )}
            </Modal>

            <Modal
                title="素材详情"
                visible={detailOpen}
                onOk={onDetailOk}
                onCancel={() => setDetailOpen(false)}
                okText="确认"
                cancelText="取消"
                width={560}
                className="detail-modal"
                getContainer={() =>
                    document.querySelector('.ceiling-modals-wrap')
                }
                footer={null}>
                <div className="content-wrap">
                    <div className="img-wrap">
                        <img src={detail.thumbnail} alt="" />
                    </div>
                    <div className="detail-wrap">
                        <p>
                            <span>模型名称：</span>
                            {detail.name}
                        </p>
                        <p>
                            <span>所属分类：</span>
                            {detail.path}
                        </p>
                        <p>
                            <span>模型尺寸：</span>
                            {getSize(detail)}
                        </p>
                        <p>
                            <span>模型ID：</span>
                            {detail.code}
                        </p>
                        <p>
                            <span>创建人：</span>
                            {detail.username}
                        </p>
                        <p>
                            <span>创建时间：</span>
                            {getDate(detail, detail.createDate)}
                        </p>
                        <p>
                            <span>更新人：</span>
                            {detail.updateTorName}
                        </p>
                        <p>
                            <span>更新时间：</span>
                            {getDate(detail, detail.updateDate)}
                        </p>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
